module.exports = __webpack_public_path__ + "static/media/thumbtack.32383c53.svg";